<script lang="ts">

    import {
        Heading,
        Radio,
        Table,
        TableBody,
        TableBodyCell,
        TableBodyRow,
        TableHead,
        TableHeadCell
    } from "flowbite-svelte";
    import posthog from "posthog-js";
    import ClearChecklistModal from "./ClearChecklistModal.svelte";
    import ColoredButton from "../colored/ColoredButton.svelte";
    import { State } from "../state.svelte";

    let {updatePercentage, clear}: {
        updatePercentage: () => void,
        clear: () => void
    } = $props();

    let clearModal: boolean = $state(false);

    const tdClass = "px-6 py-4 whitespace-nowrap font-medium light:text-gray-900";

    function setChecked(itemIndex: number, optionIndex: number) {
        for (let i = 0; i < State.checklistItems[itemIndex].options.length; i++) {
            State.checklistItems[itemIndex].options[i].checked = i === optionIndex;
        }
    }

    function handleChange(target: EventTarget | null, itemIndex: number, optionIndex: number) {
        if (target instanceof HTMLInputElement) {
            setChecked(itemIndex, optionIndex);
            updatePercentage();
            posthog.capture('checklist_item_changed', {
                item_name: State.checklistItems[itemIndex].name,
                selected_option: State.checklistItems[itemIndex].options[optionIndex].name,
            });
        }
    }

    function openClearModal() {
        clearModal = true;
    }

    function closeClearModal() {
        clearModal = false;
    }

</script>

<ClearChecklistModal bind:isOpen={clearModal} {clear} close={closeClearModal}/>

<Heading class="text-center frappe:text-ctp-pink black:text-white" tag="h2">Tasks</Heading>
<div class="sm:px-10 w-full mt-8">
    <Table color="custom"
           customeColor="frappe:bg-ctp-crust frappe:text-ctp-subtext1 light:bg-gray-200 light:text-gray-900 black:bg-gray-800 black:text-white rounded-2xl"
           class="w-full"
           noborder={true}>
        <TableHead>
            <TableHeadCell>Item</TableHeadCell>
            <TableHeadCell></TableHeadCell>
        </TableHead>
        <TableBody tableBodyClass="divide-y light:divide-gray-300">
            {#key State.checklistItems}
                {#each State.checklistItems as item, i}
                    <TableBodyRow>
                        <TableBodyCell {tdClass}>{item.name}</TableBodyCell>
                        <TableBodyCell {tdClass}>
                            <ul class="items-center w-full rounded-lg border sm:flex light:text-gray-900 light:border-gray-400 light:divide-gray-400 dark:bg-gray-800 dark:border-gray-600 divide-x rtl:divide-x-reverse">
                                {#each item.options as option, j}
                                    <li class="w-full">
                                        <Radio onchange={(e) => handleChange(e.target, i, j)}
                                               bind:checked={option.checked}
                                               value={option.name}
                                               name={item.name + "-" + i}
                                               class="p-3 text-blue-10">{option.name}</Radio>
                                    </li>
                                {/each}
                            </ul>
                        </TableBodyCell>
                    </TableBodyRow>
                {/each}
            {/key}
        </TableBody>
    </Table>

    <div class="mt-4 flex items-center justify-end py-1">
        <ColoredButton class="overflow-hidden" color="red" onclick={openClearModal}>
            Clear Checklist
        </ColoredButton>
    </div>
</div>